import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'sage' | 'peach';
}

export function Chip({ className, tone = 'sage', children, ...props }: ChipProps) {
  const toneClass = tone === 'sage' ? 'surface-sage-soft' : 'surface-peach-soft';
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 label-caps text-foreground',
        toneClass,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
